import { render, staticRenderFns } from "./knowledgenew.vue?vue&type=template&id=2bf192b3&scoped=true"
import script from "./knowledgenew.vue?vue&type=script&lang=js"
export * from "./knowledgenew.vue?vue&type=script&lang=js"
import style0 from "./knowledgenew.vue?vue&type=style&index=0&id=2bf192b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf192b3",
  null
  
)

export default component.exports